import React from "react";
import {Drawer, Typography,IconButton} from "@mui/material";
import ManageAccountDrawer from "./userDrawers/ManageAccountDrawer";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';





const ManageUserDrawer = ({ open, onClose, item, setData }) => {


    // Sample Data
    const accountData = {
        title: "Account Details",
        type: "Personal",
    };

    const listData = [
        { title: "Account Type & Applications", subtitle: `${item?.accountType}`, value: `${item?.businessUpgrade}` },
        { title: "Orders", value: `${item?.numberOfOrders}` },
        { title: "Cashback", value: `$${item?.cashBack || "0"}` },
        { title: "Tickets", value: `${item?.tickets}` },
        { title: "Mood Boards", value: `${item?.moodBoards}` },
        { title: "Recently Viewed", value: "15" },
        { title: "Wishlist", value: `${item?.wishLists}` },

    ];

    // console.log("item",item)

    return (
        <Drawer anchor="right"
            open={open}
            onClose={onClose}
            onOpen={() => { }}
            sx={{
                "& .MuiDrawer-paper": {
                    top: "0px  !important",
                    fontFamily: "Sofia Pro, sans-serif !important",
                },
                "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                    top: "0px !important"
                }
            }}
        >
            <div className="ticket-container" style={{ backgroundColor: "#fafafa" }}>
                <div className="d-flex justify-content-between align-center px-3 py-4">
                    <div>
                        <Typography
                            className="sofiaRegular"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px", mb: 0 }}
                        >
                            Manage Account
                        </Typography>
                        <Typography
                            className="sofiaRegular"
                            variant="body2"
                            sx={{ fontSize: "14px", marginBottom: 2, color: "#211f1f" }}
                        >
                            {item?.email}
                        </Typography>
                    </div>
                    <IconButton sx={{  color: 'red', cursor: "pointer", backgroundColor: "transparent",  "&:hover": {backgroundColor: "transparent" }}} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </div>
                <ManageAccountDrawer account={accountData} listItems={listData} item={item} setData={setData} />
            </div>
        </Drawer>
    );
};

export default ManageUserDrawer;







